var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPricingTemplateBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 415,
    viewBox: "0 0 1366 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26656_9240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1366,
    y: 415,
    width: 1366,
    height: 489,
    transform: "rotate(180 1366 415)",
    fill: "#4B57D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 79H243C251.837 79 259 86.1634 259 95V399C259 407.837 251.837 415 243 415H16C7.16344 415 0 407.837 0 399V79Z",
    fill: "#616EFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107 95C1107 86.1634 1114.16 79 1123 79H1366V399C1366 407.837 1358.84 415 1350 415H1123C1114.16 415 1107 407.837 1107 399V95Z",
    fill: "#616EFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 155H184C192.837 155 200 162.163 200 171V399C200 407.837 192.837 415 184 415H16C7.16344 415 0 407.837 0 399V155Z",
    fill: "#6B77FF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1166,
    y: 155,
    width: 200,
    height: 260,
    rx: 16,
    fill: "#6B77FF",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26656_9240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 415,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPricingTemplateBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pricing_template_bg.b40be87f3535146b0914b613357ceaf2.svg";